"use client";

import Link from "next/link";
import { useEffect, useState } from "react";
import { useCart } from "@/lib/cart-store";

export function CartIcon() {
  const items = useCart((s) => s.items);
  const [mounted, setMounted] = useState(false);
  useEffect(() => setMounted(true), []);
  const count = mounted ? items.reduce((sum, it) => sum + it.qty, 0) : 0;

  return (
    <Link
      href="/cart"
      aria-label={`Корзина, ${count} позиций`}
      className="relative inline-flex h-11 items-center justify-center gap-2 rounded-[8px] border border-border-strong px-3 hover:bg-bg-muted"
    >
      <svg
        aria-hidden
        width="20"
        height="20"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="1.8"
      >
        <path d="M3 3h2l3 12h12l3-9H6" strokeLinecap="round" strokeLinejoin="round" />
        <circle cx="9" cy="20" r="1.2" />
        <circle cx="18" cy="20" r="1.2" />
      </svg>
      <span className="hidden text-sm font-medium md:inline">Корзина</span>
      {count > 0 && (
        <span className="absolute -right-2 -top-2 inline-flex h-5 min-w-[20px] items-center justify-center rounded-full bg-accent-600 px-1.5 text-xs font-semibold text-white">
          {count}
        </span>
      )}
    </Link>
  );
}
